import { render, staticRenderFns } from "./Instruments.vue?vue&type=template&id=04704a3c&scoped=true&"
import script from "./Instruments.vue?vue&type=script&lang=js&"
export * from "./Instruments.vue?vue&type=script&lang=js&"
import style0 from "./Instruments.vue?vue&type=style&index=0&id=04704a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04704a3c",
  null
  
)

export default component.exports